import { Body, Stack } from "@biom3/react";
import { Countdown } from "@components/Countdown/Countdown";
import { EOAWalletDisconnect } from "./EOAWalletDisconnect";

type GemsClaimedProps = {
  isPassportWallet: boolean;
  disconnect: () => Promise<void>;
  onUTCDayChange: () => void;
  walletAddress: string;
};
export const GemsClaimed = ({
  onUTCDayChange,
  isPassportWallet,
  disconnect,
  walletAddress,
}: GemsClaimedProps) => {
  return (
    <Stack direction="column" alignItems="left" gap="0">
      <>
        {walletAddress && !isPassportWallet ? (
          <EOAWalletDisconnect
            walletAddress={walletAddress}
            disconnect={disconnect}
          />
        ) : null}
        <Body
          size="small"
          weight="regular"
          color="secondary"
          sx={{ mb: "base.spacing.x1", mt: "base.spacing.x2" }}
        >
          Next Claim
        </Body>
        <Countdown onUTCDayChange={onUTCDayChange} />
      </>
    </Stack>
  );
};
